import React from 'react'
import { motion } from 'framer-motion'
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaUser } from 'react-icons/fa'
import './Contact.css'

const Contact = () => {
  const contactInfo = [
    {
      icon: FaMapMarkerAlt,
      title: 'Adresa',
      details: [
        'Chata JÍLOVANKA',
        'Zdobnice 5',
        '516 01 Rychnov nad Kněžnou'
      ]
    },
    {
      icon: FaPhone,
      title: 'Telefon',
      details: [
        '(+420) 775 112 341'
      ]
    },
    {
      icon: FaEnvelope,
      title: 'Email',
      details: [
        'info@penzionjilovanka.cz'
      ]
    },
    {
      icon: FaUser,
      title: 'Majitel',
      details: [
        '	Chata Jílovanka s.r.o.',
        'IČ: 10855408'
      ]
    }
  ]

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  }

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  }

  return (
    <section className="contact-section section" id="kontakt">
      <div className="container">
        <motion.div
          className="contact-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h1 className="section-title">Kontakt</h1>
          <p className="section-subtitle">
            Rádi vám odpovíme na všechny vaše dotazy
          </p>
        </motion.div>

        <div className="contact-content">
          <motion.div
            className="contact-info"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {contactInfo.map((info, index) => {
              const Icon = info.icon
              return (
                <motion.div
                  key={index}
                  className="contact-card"
                  variants={itemVariants}
                  whileHover={{ 
                    scale: 1.05,
                    transition: { duration: 0.2 }
                  }}
                >
                  <div className="contact-icon">
                    <Icon />
                  </div>
                  <h3 className="contact-title">{info.title}</h3>
                  <div className="contact-details">
                    {info.details.map((detail, detailIndex) => (
                      <p key={detailIndex} className="contact-detail">
                        {detail}
                      </p>
                    ))}
                  </div>
                </motion.div>
              )
            })}
          </motion.div>

          <motion.div
            className="contact-map"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <div className="map-container">
              <h3>Poloha</h3>
              <div className="map-placeholder">
                <FaMapMarkerAlt className="map-icon" />
                <p>Mapa bude brzy k dispozici</p>
                <p className="map-coordinates">50.24095789519349, 16.4046010244367</p>
              </div>
            </div>
          </motion.div>
        </div>

        <motion.div
          className="contact-cta"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <h3>Chcete si rezervovat pobyt?</h3>
          <p>Kontaktujte nás telefonicky nebo emailem a rádi vám pomůžeme s rezervací.</p>
          <div className="cta-buttons">
            <a href="tel:775112341" className="btn btn-primary">
              <FaPhone />
              Zavolat
            </a>
            <a href="mailto:info@penzionjilovanka.cz" className="btn btn-secondary">
              <FaEnvelope />
              Napsat email
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  )
}

export default Contact
